import React from "react";
import { Link } from "gatsby";

import BRAND_LOGO from "../images/sub_brand_logo.svg";

export default function LatestHeader() {
	return (
		<header className="latest-pet">
			<Link className="header-logo latest-pet" to="/">
				<img src={BRAND_LOGO} alt="brand_logo" />
			</Link>
		</header>
	);
}
